<template>
    <div id="wrapper" :key="valuekey">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.truck.register.title')}}</h4>

                            </div>
                        </div>
                    </div>

                    <!-- Form row -->
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card-box">
                                <p class="sub-header">
                                    {{$t('string.msg.truck.register.description')}}
                                </p>
                                <form>

                                    <div v-if="data._id" class="form-row">
                                        <div class="form-group col-md-4">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.product.brand.label.id')}}
                                            </label>
                                            <input type="text" readonly v-model="data._id" class="form-control">
                                        </div>
                                        <div class="form-group col-md-2">
                                            <br/>
                                            <br/>
                                            <button v-on:click="confirmArchive" class="text-dark-gray btn btn-warning w-100">{{$t('string.msg.status.archive')}}</button>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.truck.register.manufacturs.label')}}
                                            </label>
                                            <select id="manufacturer" v-model="data.manufacturer" class="form-control"  @change="onChange(data.manufacturer)">
                                                <option :value="null" selected>{{$t('string.msg.select.selector.item')}}</option>
                                                <option :value="item._id" v-bind:key="item" v-for="item in manufacturers">{{camelize(item.name).split('ZZZ_').join('')}}</option>
                                            </select>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.truck.register.label.model')}}
                                            </label>
                                           <select id="model" v-model="data.model" class="form-control">
                                                <option :value="null" selected>{{$t('string.msg.select.selector.item')}}</option>
                                                <option :value="item._id" v-bind:key="item" v-for="item in models">{{$t(item.name)}}</option>
                                            </select>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.register.truck.label.type')}}
                                            </label> 
                                            <select id="truck" v-model="data.vehicleType" class="form-control">
                                                <option :value="null" >{{$t('string.msg.select.selector.item')}}</option>
                                                <option :value="item._id" v-bind:key="item" v-for="item in truckTypes">{{$t(item.name)}}</option>
                                            </select>
                                        </div>

                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                 {{$t('string.msg.register.truck.type.model.label.group')}}
                                            </label>
                                            <input type="text" v-model="data.groupType" class="form-control" :placeholder="$t('string.msg.truck.register.placeholder.model')">
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.truck.register.label.traction')}}
                                            </label>
                                            <select id="truck" v-model="data.traction" class="form-control">
                                                <option :value="null" selected>{{$t('string.msg.select.selector.item')}}</option>
                                                <option :value="item._id" v-bind:key="item" v-for="item in Tractions">{{$t(item.name)}}</option>
                                            </select>
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.truck.register.label.plate')}}
                                            </label>
                                            <input type="text" onkeyup="this.value = this.value.toUpperCase();" v-model="data.plate" class="form-control" v-mask="['AAA #X##']" :placeholder="$t('string.msg.truck.register.placeholder.plate')">
                                        </div>
                                     
                                    </div>
                                  
                                    <div class="form-row">
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                {{$t('string.msg.truck.register.label.renavam')}}
                                            </label>
                                            <input type="text" v-model="data.renavam" class="form-control" :placeholder="$t('string.msg.truck.register.placeholder.renavam')">
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.truck.register.label.year.manufacture')}}
                                            </label>
                                            <input  type="tel" v-mask="'####'" v-model="data.year" class="form-control"  :placeholder="$t('string.msg.truck.register.placeholder.year.manufacture')">
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.trucktrailer.register.label.year.model.manufacture')}}
                                            </label>
                                            <input type="tel" v-mask="'####'" v-model="data.yearModel" class="form-control" :placeholder="$t('string.msg.trucktrailer.register.placeholder.year.model')">
                                        </div>
                                        
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                {{$t('string.msg.truck.register.label.kilometer')}}
                                            </label>
                                            <input type="text"  v-model="data.actualKM" class="form-control"  v-mask="['#', '##', '###', '#.###', '##.###', '###.###', '#.###.###','##.###.###']" :placeholder="$t('string.msg.truck.register.placeholder.kilometer')">
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                {{$t('string.msg.truck.register.label.chassis')}}
                                            </label>
                                            <input type="text" onkeyup="this.value = this.value.toUpperCase();" v-model="data.chassi" class="form-control" :placeholder="$t('string.msg.truck.register.placeholder.chassis')">
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                {{$t('string.msg.truck.register.label.color')}}
                                            </label>
                                            <input type="text" v-model="data.color" class="form-control" :placeholder="$t('string.msg.truck.register.placeholder.color')">
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                {{$t('string.msg.register.truck.label.pbt')}}
                                            </label>
                                            <input type="text"  v-model="data.pbt" class="form-control"  v-mask="['#', '##', '###', '####']" :placeholder="$t('string.msg.register.truck.placeholder.pbt')">
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                               {{$t('string.msg.truck.register.document.number.label')}}
                                            </label>
                                            <input type="text" v-model="data.document" class="form-control" :placeholder="$t('string.msg.truck.register.placeholder.document')">
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                {{$t('string.msg.truck.register.photo.document.label')}}
                                            </label>
                                                <input type="file" accept="image/png, image/jpeg" id="file" ref="file" v-on:change="handleFileUpload()" class="form-control">
                                        </div>
                                        <div v-if="data.documentPhotoURL" class="form-group col-md-5">
                                            <label class="col-form-label">
                                                {{$t('response.truck.register.document.preview.photo')}}
                                            </label>
                                            <div class="card border border-secondary">
                                                <div v-if="data.documentPhotoURL" @click="showPhoto(data.documentPhotoURL)" class="card-body text-secondary text-center">
                                                    <img v-bind:src="`${domain}${data.documentPhotoURL}`" alt="image" height="180" width="250">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <br/>
                                    <p class="sub-header">
                                        {{$t('string.msg.truck.register.certified.description')}}
                                    </p>

                                    <div class="form-row">

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                {{$t('string.msg.truck.certified.label')}}
                                            </label>
                                            <select id="truck" v-model="certifie" class="form-control">
                                                <option value="-1" selected>{{$t('string.msg.select.selector.item')}}</option>
                                                <option :value="item" v-bind:key="item" v-for="item in certifies">{{$t(item.name)}}</option>
                                            </select>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                {{$t('string.msg.register.truck.label.date.exp')}}
                                            </label>
                                                 <input type="text" v-model="shippingDate" class="form-control" v-mask="['##/##/####']" :placeholder="$t('string.msg.register.truck.placeholder.date.exp')">
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                {{$t('string.msg.register.truck.label.date.validate')}}
                                            </label>
                                              <input type="text" v-model="expiredDate" class="form-control" v-mask="['##/##/####']" :placeholder="$t('string.msg.register.truck.placeholder.date.validate')">
                                        </div>

                                        
                                    </div>

                                    <div class="form-row">
                                       <div class="form-group col-md-3">
                                            <label class="col-form-label">
                                                 {{$t('string.msg.truck.register.photo.document.label')}}
                                            </label>
                                            <input type="file" accept="image/png, image/jpeg" id="fileCertifie" ref="fileCertifie" v-on:change="handleFileUpload()" class="form-control">
                                        </div>
                          
                                        <div class="form-group col-md-6">
                                            <br>
                                            <br>
                                            <div class="d-flex justify-content-between bd-highlight mb-3">
                                                <button @click="add" class="btn btn-warning w-20 text-dark-gray">{{$t('string.msg.form.btn.add')}}</button>
                                            </div>
                                        </div>
                                        <br>
                                        <br>
                                        
                                    </div>


                                    <br>
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th scope="col">{{$t('string.msg.truck.table.header.certifie')}}</th>
                                                <th scope="col">{{$t('string.msg.register.truck.label.date.exp')}}</th>
                                                <th scope="col">{{$t('string.msg.parts.perfil.truck.table.header.date.validate')}}</th>
                                                <th scope="col">{{$t('string.msg.truck.table.header.photo')}}</th>
                                                <th scope="col">{{$t('string.msg.register.truck.table.header.remove')}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                           <tr v-bind:key="item" v-for="item in data.certifies">
                                                <td v-if="item && item.certified">{{camelize(item.certified.name)}}</td>
                                                <td v-if="item.shippingDate">{{new Date(item.shippingDate).toLocaleDateString()}}</td>
                                                <td v-else>{{$t('string.msg.invalid.date')}}</td>
                                                <td v-if="item.expiredDate">{{new Date(item.expiredDate).toLocaleDateString()}}</td>
                                                <td v-else>{{$t('string.msg.invalid.date')}}</td>

                                                <td v-if="item.photoURL" @click="showPhoto(item.photoURL)" class="cursor-pointer">
                                                    <img v-bind:src="`${domain}${item.photoURL}`" alt="image" height="180" width="250">
                                                </td>
                                                <td v-else>{{$t('string.msg.certified.nothing.photo')}}</td>
                                                <td v-if="item && item.certified">
                                                    <button @click="remove(item.certified._id)" class="btn btn-danger w-20">X</button>
                                                </td>
                                                
                                            </tr>
                                        </tbody>
                                    </table>

                                    <br/>
                                    <p class="sub-header">
                                        {{$t('string.msg.truck.register.label.trucktrailer')}}
                                    </p>

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                {{$t('string.msg.connect.truck.register.trucker')}}
                                                <span class="ml-2" style="color: red;">{{$t('str.obs.trucker.view')}}</span>
                                            </label>
                                            <select v-model="data.truckDriver" class="form-control">
                                                <option :value="null" selected>{{$t('string.msg.connect.truck.placeholder.register.trucker')}}</option>
                                                <option :value="item._id" v-bind:key="item._id" v-for="item in truckers" >{{camelize(item.firstName) + 
                                                    ' ' + camelize(item.lastName)}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <br><br>
                                    <div class="form-row">
                                        <div class="form-group col-md-6 text-center">
                                            <button @click="clearForm" class="btn btn-secondary w-50">{{$t('string.msg.form.btn.clear')}}</button>
                                        </div>

                                        <div class="form-group col-md-6 text-center">
                                            <button v-on:click="checkForm" class="btn btn-danger w-50">{{$t('string.msg.form.btn.save')}}</button>
                                        </div>
                                    </div>
                                    <br/>
                                    <div v-if="errors.length" class="alert alert-danger">
                                        <p class="lead">{{$t('response.msg.error.empty.fields')}}</p>
                                        <ul>
                                            <li v-bind:key="error" v-for="error in errors">{{ error }}</li>
                                        </ul>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                    <List v-on:load-item="selectItem" />
                </div>
            </div>
        </div>
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
        <Confirmation :title="titleToast" :message="messageToast" :cancelText="cancelText" :yesText="yesText" v-on:confirmation-return="archive" />
        <Photo :photoURL="photoURL" />
        <FlashMessage/>
    </div>
</template>

<script>
import Controller from './CrtTruck';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';
import Confirmation from '../../../components/layout/Confirmation';
import Photo from '../../../components/layout/ModalPhoto';
import List from './ListTruck';
import {ptBR} from 'vuejs-datepicker/dist/locale'
import Vue from 'vue';
Vue.prototype.$eventHub = new Vue();

export default {
  name: 'Truck',
  components: {
    Spinner,
    Toast,
    List,
    Confirmation,
    Photo
  },
  data() {
      return {
        search:'',
        errors: [],
         disabledDates: {
        },
        ptBR: ptBR,
        valuekey: 0,
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        certifies: [],
        manufacturers: [],
        models: [],
        truckTypes:[],
        truckers:[],
        Tractions:[],
        photoURL: null,
        certifie: null,
        certifiePhotoURL:null,
        company: null,
        file: null,
        data: {
            manufacturer: null,
            model: null,
            year: null,
            yearModel: null,
            plate: null,
            renavam: null,
            mouths: null,
            chassi: null,
            color: null,
            truckDriver: null,
            systemUser: null,
            certifies: [],
            vehicleType: null,
            document: null,
            documentPhotoURL: null,
            actualKM: null,
            groupType:null,
            traction: null,
            pbt: null,
            company: null,
        },
    }
  },
  methods: Controller.methods,
  created() {
    Controller.init(this);
    
  },
  computed: {
  },
  mounted(){
  }
}
</script>

